/**
 * Build the canonical experience URL path including city segment.
 * Falls back to /experiences/{slug} if city_slug is unavailable.
 */
export function experienceUrl(slug: string, citySlug?: string | null): string {
  if (citySlug) return `/experiences/${citySlug}/${slug}`;
  return `/experiences/${slug}`;
}
